import { useWizard } from '../../context/WizardContext';
import { Button } from '../UI/Button';
import { ArrowRight } from 'lucide-react';

export function WelcomeStep() {
  const { nextStep } = useWizard();

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] animate-fade-in">
      <div className="text-center max-w-lg">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">
          Solicita tu factura
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          Toma 2–3 minutos. Ten tu ticket y tu constancia fiscal a la mano.
        </p>
        <Button
          onClick={nextStep}
          size="lg"
          icon={ArrowRight}
          className="w-full sm:w-auto"
        >
          Comenzar
        </Button>
      </div>
    </div>
  );
}
